<template>
  <div class="teams-wrapper">
    <div class="teams-widget">
      <multipane class="custom-resizer" layout="vertical">
        <div class="teams-list">
          <div class="teams-header">
            <div class="team-info">
              <h1 class="team-title">All Members</h1>
              <div class="path">
                <span>All Teams > {{ team_data.name }}</span>
              </div>
            </div>

            <div class="options">
              <button class="btn-add" @click="addNewMember()">
                Add Member <img src="@/assets/admin-icon/circle-blue-add.svg" />
              </button>
            </div>
          </div>
          <div class="teams-body tab-body">
            <h1 class="team-title">Members</h1>
            <table class="table-data" border="0">
              <thead class="table-header">
                <tr>
                  <th>Consultants</th>
                  <th>Location</th>
                  <th>Email adress</th>
                  <th>Phone</th>
                  <th></th>
                </tr>
              </thead>
              <tbody class="table-body">
                <tr v-for="(item, index) in team_data.consultants" :key="index">
                  <td>
                    <div class="tb-profile-widget">
                      <div
                        class="profile-alphabet"
                        v-if="!item.profile_picture"
                      >
                        <span>
                          {{
                            $nameInitials(
                              item.first_name + " " + item.last_name
                            ) | validate
                          }}
                        </span>
                      </div>
                      <img
                        v-else
                        class="profile-image"
                        :src="
                          $fullUrl('images/profiles/' + item.profile_picture)
                        "
                      />
                      <span class="names">{{
                        (item.first_name + " " + item.last_name) | validate
                      }}</span>
                    </div>
                  </td>
                  <td v-if="item.profile">
                    {{ item.profile.address | validate }}
                  </td>
                  <td>{{ item.email | validate }}</td>
                  <td v-if="item.profile">
                    {{ item.profile.phone | validate }}
                  </td>

                  <td>
                    <dropdownMenu>
                      <ul>
                        <li>
                          <app-dialog
                            title="Remove Member"
                            ask="Are you sure you want to permanently remove this member?"
                            yesText="Delete"
                            noText="Cancel"
                            @onComfirm="removeMember(team_data.id, item.id)"
                          >
                            <a href="#">Remove</a>
                          </app-dialog>
                        </li>
                      </ul>
                    </dropdownMenu>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <multipane-resizer></multipane-resizer>
        <div class="teams-details" :style="{ flexGrow: 1 }">
          <div
            class="team-details-widget"
            v-for="(item, index) in team_data.managers"
            :key="index"
          >
            <div class="profile-picture">
              <div class="profile-alphabet" v-if="!item.profile_picture">
                <span>
                  {{
                    $nameInitials(item.first_name + " " + item.last_name)
                      | validate
                  }}
                </span>
              </div>
              <img
                v-else
                class="profile-image"
                :src="$fullUrl('images/profiles/' + item.profile_picture)"
              />
            </div>
            <div class="team-name">
              <h1>{{ (item.first_name + " " + item.last_name) | validate }}</h1>
            </div>
            <p class="location" v-if="item.profile">
              {{ item.profile.address | validate }}
            </p>
            <p class="phone" v-if="item.profile">
              {{ item.profile.phone | validate }}
            </p>
            <p class="email">{{ item.email | validate }}</p>
            <p
              class="description"
              v-if="item.profile"
              v-html="item.profile.description"
            ></p>
          </div>
        </div>
      </multipane>
    </div>

    <!-- Team Add - Update Modal -->
    <div class="overlay" v-if="show_form">
      <div class="form-widget-modal">
        <div class="moder-header">
          <h4 v-if="!form.id">Update members</h4>
          <h4 v-else>Update team</h4>
        </div>
        <div class="modal-body">
          <div class="input-group">
            <label>Add members</label>
            <searchSelectInput
              url="/search/people"
              :miltiple="true"
              type="site"
              v-model="members"
              placeholder="Search for members..."
            >
              <template v-slot:result="{ result }">
                <span class="search-contact-item"
                  ><img
                    width="20"
                    v-if="result.profile_picture"
                    :src="$fullUrl('images/profiles/' + result.profile_picture)"
                  />
                  <img v-else width="20" src="@/assets/avatar.png" />
                  {{ result.first_name | validate }}
                  {{ result.last_name | validate }}</span
                >
              </template>
              <template v-slot:selected="{ selected }">
                <span class="selected-search-contact-item">
                  <img
                    width="20"
                    v-if="selected.profile_picture"
                    :src="
                      $fullUrl('images/profiles/' + selected.profile_picture)
                    "
                  />
                  <img v-else width="20" src="@/assets/avatar.png" />
                  {{ selected.first_name | validate }}</span
                >
              </template>
            </searchSelectInput>
          </div>
        </div>
        <div class="modal-footer">
          <c-button
            :loading="team_loading"
            @click="submitMember()"
            class="btn-save"
            >Save</c-button
          >
          <button class="btn-cancel" @click="show_form = false">Cancel</button>
        </div>
      </div>
    </div>
    <!-- End -->
  </div>
</template>

<script>
import { eventBus } from "@/main";
import { mapGetters } from "vuex";
import moment from "moment";

export default {
  name: "teams",
  components: {},
  props: {},
  data: () => {
    return {
      team_data: {},
      form: {
        crm_team_id: null,
        members_added: [],
        members_removed: [],
      },
      members: {
        added: [],
        removed: [],
      },
      show_form: false,
      team_loading: false,
    };
  },
  mounted() {
    let vm = this;
    vm.getTeamData();
  },
  computed: {},
  methods: {
    removeMember(team_id, member_id) {
      let vm = this;
      vm.$store
        .dispatch("ORGANIZATION_TEAM_REMOVE_MEMBER", {
          id: team_id,
          member_id: member_id,
        })
        .then((response) => {
          vm.getTeamData();
          vm.$notify({
            group: "status",
            title: "Message",
            text: "Member have been removed",
            type: "success",
            duration: 3000,
          });
        })
        .catch((error) => {
          console.error({ error });
        });
    },
    submitMember() {
      let vm = this;
      //For consultant
      vm.form.members_added = vm.members.added.map((item) => {
        return item.id;
      });
      const rules = {
        members_added: {
          run: (value) => {
            if (!vm.form.id) {
              if (value.length > 0) {
                return false;
              } else {
                return "Please add some members";
              }
            }
            return false;
          },
        },
      };
      if (vm.$isFieldsValidated(vm.form, rules)) {
        vm.team_loading = true;
        vm.$store
          .dispatch("ORGANIZATION_ADD_NEW_TEAM_MEMBERS", vm.form)
          .then((response) => {
            vm.getTeamData();
            vm.team_loading = false;
            vm.show_form = false;
            vm.$notify({
              group: "status",
              title: "Message",
              text: "Members have been added",
              type: "success",
              duration: 3000,
            });
          })
          .catch((error) => {
            console.error({ error });
            vm.team_loading = false;
          });
      }
    },
    addNewMember(item) {
      let vm = this;
      vm.show_form = true;
      vm.members = {
        added: [],
        removed: [],
      };
      vm.form = {
        crm_team_id: vm.$route.params.team_id,
        members_added: [],
        members_removed: [],
      };
    },
    getTeamData() {
      let vm = this;
      let team_id = vm.$route.params.team_id;
      vm.$store
        .dispatch("ORGANIZATION_GET_TEAM_DATA", {
          id: team_id,
        })
        .then((response) => {
          vm.team_data = response.data;
        })
        .catch((error) => {
          console.error({ error });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
$assets: "~@/assets";
.teams-wrapper {
  width: 100%;
  height: calc(100% - 0px);
  display: flex;
  flex-direction: column;
  .teams-widget {
    height: 100%;
    position: relative;

    .teams-list {
      display: flex;
      flex-direction: column;
      height: 100%;
      min-width: calc(100% - 400px);
      width: 100%;
      .teams-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: #fff;
        padding: 10px 10px;
        border-radius: 5px;
        margin-bottom: 15px;
        height: 70px;
        .team-title {
          font-size: 20px;
          font-weight: 800;
          margin: 0px;
        }
        .options {
          display: flex;
          align-items: center;
          justify-content: space-between;
          .btn-add {
            background: #0884af;
            border-radius: 5px;
            color: #fff;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding-left: 16px;
          }
        }
      }
      .teams-body {
        background: #fff;
        padding: 10px 10px;
        border-radius: 5px;
        height: calc(89vh - 100px);
        overflow-y: auto;
        .team-title {
          font-size: 17px;
        }
        .table-data {
          width: 100%;
          border-collapse: collapse;
          border-spacing: 0;
          tr {
            th,
            td {
              text-align: left;
              padding: 10px;
              border: none;
            }
            td {
              background: #f7f7f7;
              border-bottom: 4px solid #fff;
              .tb-profile-widget {
                display: flex;
                align-items: center;
                .profile-alphabet {
                  height: 40px;
                  width: 40px;
                  background: #1ba5a438;
                  border-radius: 50%;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  color: #1ba5a4;
                  font-size: 18px !important;
                  margin-right: 16px;
                }
                .profile-image {
                  height: 40px;
                  width: 40px;
                  background: #1ba5a438;
                  border-radius: 50%;
                }
                .names {
                  margin-left: 10px;
                }
              }
            }
          }
        }
      }
    }
    .teams-details {
      width: 300px;
      min-width: 300px;
      max-width: 400px;
      .team-details-widget {
        background: #fff;
        border-radius: 5px;
        width: 100%;
        padding: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        .profile-picture {
          display: flex;
          align-items: center;
          justify-content: center;
          .profile-alphabet {
            height: 60px;
            width: 60px;
            background: #1ba5a438;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #1ba5a4;
            font-size: 18px !important;
            margin-right: 16px;
          }
          .profile-image {
            height: 40px;
            width: 40px;
            background: #1ba5a438;
            border-radius: 50%;
          }
        }
        .team-name {
          border-bottom: 1px solid #ccc;
          width: 100%;
          margin-bottom: 20px;
          h1 {
            text-align: center;
            font-size: 20px;
            color: #0884af;
          }
        }
        p {
          margin-bottom: 4px;
          margin-top: 4px;
        }
        .description {
          text-align: center;
        }
      }
    }
  }
  .form-widget-modal {
    width: 500px;
    min-height: 200px;
    padding: 20px;
  }
}

.search-contact-item {
  padding: 10px 15px;
  display: flex;
  cursor: pointer;
  align-items: center;
  img {
    border-radius: 50%;
    margin-right: 8px;
  }
  &:hover {
    background: rgb(250, 250, 250);
  }
}
.selected-search-contact-item {
  padding: 5px 12px;
  display: flex;
  align-items: center;
  cursor: pointer;
  border: 1px solid #ddd;
  margin-top: 10px;
  border-radius: 15px;
  font-size: 11px;
  img {
    border-radius: 50%;
    margin-right: 8px;
  }
  &:hover {
    background: rgb(250, 250, 250);
  }
}
</style>
